'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = _util2.default.create,
    setSpvStorage = _util2.default.setSpvStorage,
    getSpvFromStorage = _util2.default.getSpvFromStorage;

var Label = function (_EventEmitter) {
  (0, _inherits3.default)(Label, _EventEmitter);

  function Label(data, type) {
    (0, _classCallCheck3.default)(this, Label);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Label.__proto__ || (0, _getPrototypeOf2.default)(Label)).call(this));

    _this.data = data;
    // type = 'GIFT'
    if (type === 'GIFT') {
      _this.setSpvFromStorage();
    }
    _this.data.labelType = type;
    // console.log('label:', this.data.g_uid)
    _this.type = type;
    _this.setTransformedData();
    return _this;
  }

  (0, _createClass3.default)(Label, [{
    key: 'setSpvFromStorage',
    value: function setSpvFromStorage() {
      if (_util2.default.getClient() !== 'mobile' || !this.data.hasVariants) {
        return;
      }
      var spv = getSpvFromStorage(this.data.productId, 'label');
      if (!spv || spv.id === this.data.spv.id) {
        return;
      }
      this.data.spv = spv;
    }
  }, {
    key: 'setVariant',
    value: function setVariant(_ref) {
      var _this2 = this;

      var result = _ref.result,
          variant = _ref.variant;

      variant.spvs.forEach(function (spv) {
        if (spv.id === result.spvId) {
          _this2.data.spv = spv;
          if (_util2.default.getClient() === 'mobile') {
            setSpvStorage(_this2.data, 'label');
          }
        }
      });
      return _promise2.default.resolve();
    }
  }, {
    key: 'setTransformedData',
    value: function setTransformedData() {
      var data = this.data;
      if (this.type === 'LABEL') {
        var v = _util2.default.clone(data);
        var mode = v.mode;
        // campaign which has not campaign info should display as 'TEXT'
        if (mode === 'CAMPAIGN' && !v.campaign) {
          mode = 'TEXT';
        }
        v.class = 'type-label ';
        switch (mode) {
          case 'TEXT':
            v.rightDesc = '';
            v.class += 'text ';
            v.class += v.valid ? 'full-width' : 'invalid full-width';
            break;
          case 'CAMPAIGN':
            v.rightDesc = v.campaign.linkDesc;
            v.class += 'campaign ';
            if (v.jump === true) {
              v.class += 'link ';
            } else {
              v.class += 'not-jump ';
            }
            if (!v.campaign.fulfilled) {
              v.class += 'not-fulfilled';
            }
            break;
          case 'POSTAGE':
            v.rightDesc = v.postage.linkDesc;
            v.class += 'postage ';
            v.class += 'link ';
            if (!v.postage.fulfilled) {
              v.class += 'not-fulfilled';
            }
            break;
          default:
            v.rightDesc = '';
            v.class += v.valid ? 'full-width' : 'invalid full-width';
        }
        // return v
        this.data.transformedData = v;
      }
      if (this.type === 'GIFT') {
        var labelType = 'type-gift';
        var el = data;
        var campaignInfo = void 0;
        if (!el.campaign || !el.campaign.info) {
          campaignInfo = {
            // type: '赠品',
            // typeBgColor: '#537371',
            // typeColor: '#FFFFFF',
            // summaryColor: '#000'
          };
        } else {
          campaignInfo = el.campaign.info;
        }

        this.data.transformedData = {
          count: el.count,
          link: el.link,
          summary: el.spv.name + ' ' + el.spv.spvDesc,
          summaryColor: '' + campaignInfo.summaryColor,
          type: '' + campaignInfo.type,
          typeBgColor: '' + campaignInfo.typeBgColor,
          typeColor: '' + campaignInfo.typeColor,
          // valid: true,
          rightDesc: el.owned ? el.hasVariants ? '已获得，选规格' : '已获得' : '已赠完',
          class: el.owned ? el.hasVariants ? labelType + ' link' : '' + labelType : labelType + ' invalid'
        };
      }
    }
  }, {
    key: 'labelTap',
    value: function labelTap() {
      var data = this.data;
      if (this.type === 'LABEL') {
        this.jump(data);
      }
      if (this.type === 'GIFT' && data.owned && data.hasVariants) {
        this.selectVariant();
      }
    }
  }, {
    key: 'jump',
    value: function jump(data) {
      switch (data.mode) {
        case 'CAMPAIGN':
          if (!data.campaign || !data.jump) {
            return;
          }
          if (isApp) {
            window.location.href = 'beastapp://search?campaignId=' + data.campaign.id + '&canAdd2Cart=1&title=' + data.campaign.name;
          } else {
            this.emit('label-jump', {
              campaignId: data.campaign.id,
              canAdd2Cart: true,
              title: data.campaign.name
            });
          }
          //window.location.href = `/app/item/activityOrder.htm?title=${data.campaign.name}&actionId=${data.campaign.id}`
          break;
        case 'POSTAGE':
          if (isApp) {
            window.location.href = 'beastapp://search?canAdd2Cart=1&forPostage=true';
          } else {
            this.emit('label-jump', {
              canAdd2Cart: true,
              forPostage: true
            });
          }
          break;
      }
    }
  }, {
    key: 'selectVariant',
    value: function selectVariant() {
      var _this3 = this;

      if (this.pending) {
        return;
      }
      this.pending = true;
      _util2.default.selectVariant({
        pack: this.data
      }).then(function (_ref2) {
        var result = _ref2.result,
            variant = _ref2.variant;

        _this3.pending = false;
        // for android
        result.spvId = parseInt(result.spvId);
        if (result.spvId === _this3.data.spv.id) {
          return;
        }
        variant.spvs.forEach(function (spv) {
          if (spv.id === result.spvId) {
            _this3.data.spv = spv;
            if (_util2.default.getClient() === 'mobile') {
              setSpvStorage(_this3.data, 'label');
            }
          }
        });
      }).catch(function (error) {
        _this3.pending = false;
      });
    }
  }, {
    key: 'editMode',
    value: function editMode(val) {
      this.data.editMode = val;
    }
  }]);
  return Label;
}(_events.EventEmitter);

exports.default = Label;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/base/label.js
// module id = 671
// module chunks = 0